let host=process.env.VUE_APP_HOST;

export default host
